import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { PRICE_REQUEST_INLINE_CTA_COOKIE } from './experiments.constants';

@Injectable({
  providedIn: 'root',
})
export class PriceRequestExperimentService {
  private readonly cookieService = inject(CookieService);

  isPriceRequestInlineCtaExperimentActive(): boolean {
    // Check if the experiment cookie is present and set to 'true'
    return this.cookieService.check(PRICE_REQUEST_INLINE_CTA_COOKIE) && this.cookieService.get(PRICE_REQUEST_INLINE_CTA_COOKIE) === 'true';
  }
}
